import type { Spec } from '@/types';
import styles from './ProductDetailInfo.module.scss';

type ProductDetailInfoProps = {
  specs: Spec[];
  description: string;
};

function ProductDetailInfo({ specs, description }: ProductDetailInfoProps) {
  return (
    <>
      <div className={styles.productSpecContainer}>
        <div className={styles.productSpecItem}>
          {specs.length > 0 &&
            specs.map((spec) => (
              <div className={styles.spec} key={spec.id}>
                <span>{spec.key}</span>
                <span>:</span>
                <span>{spec.value}</span>
              </div>
            ))}
        </div>
      </div>
      <div className={styles.productDescriptionContainer}>
        <p className={styles.productDescription}>{description}</p>
      </div>
    </>
  );
}

export default ProductDetailInfo;
